<template>
    <div>
      <div class="d-flex" id="wrapper">
        <SideBar />
        <div id="page-content-wrapper">
          <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
              <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
              </button>
    
              <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
              </button>
            </div>
            <div class="d-flex">
              <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
              <p class="text-primary mb-0 hover-cursor">&nbsp; Assembly</p>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <h5 class="card-title mt-3 mb-5">Perubahan Sparepart</h5>
                </div>
                <div class="container">
                  <div class="row align-items-start my-2">
                    <div class="col-lg-2 mt-2">
                      Warehouse
                    </div>
                    <div class="col-lg-10 pl-0 mb-2">
                        <multiselect v-model="warehouse" :options="selectWarehouse" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Pilih Warehouse"></multiselect>
                    </div>
                    <div class="col-lg-2 mt-2" v-if="warehouse">
                      SC/SN
                    </div>
                    <div class="col-lg-10 pl-0" v-if="warehouse">
                      <div class="position-relative">
                        <input type="text" v-model="snsc" class="form-control pr-5" v-on:keyup.enter="doSearchSn">
                        <small
                          v-if="snsc"
                          class="text-muted"
                          style="
                            position: absolute;
                            top: 50%;
                            right: 15px;
                            transform: translateY(-50%);
                            pointer-events: none;
                          "
                        >
                          Enter to search ⏎
                        </small>
                      </div>
                    </div>
                    <div class="col-lg-2 mt-2" v-if="itemChoose">
                      
                    </div>
                    <div class="col-lg-10 mt-2" v-if="itemChoose">
                      <div class="info-header">Info Unit</div>
                      <div class="laptop-info-container">
                        <!-- Info Unit Section -->
                        <div class="info-unit-section">
                          <div class="info-content">
                            <div class="info-item laptop-title">
                              {{itemChoose.itemGroup}} - {{itemChoose.itemName}}
                            </div>
                            <div class="info-item laptop-title">
                              {{itemChoose.stockCode}} / {{itemChoose.id}}
                            </div>
                            <div v-for="(item,i) in itemChoose.bomItem" :key="`${item.itemGroup}-${i}`">
                              <div class="info-item laptop-title">
                                {{item.itemName}}
                              </div>   
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Action Buttons -->
                    <div class="col-lg-2" v-if="itemChoose"></div>
                    <div class="col-lg-10" v-if="itemChoose">
                      <div class="button-group">
                        <button class="action-btn btn-edit" @click="openModal('modalChangeMainPart')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.88894 7.22222L1.77783 4.11111M1.77783 4.11111L4.88894 1M1.77783 4.11111L14.2223 4.11111M11.1112 8.77778L14.2223 11.8889M14.2223 11.8889L11.1112 15M14.2223 11.8889L1.77783 11.8889" stroke="#2E3646" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          Ganti Part Utama
                        </button>
                        <button class="action-btn btn-delete" @click="openModal('modalChangeWithOtherPart')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8403 3.02508C11.2181 3.14175 11.5792 3.29175 11.9237 3.47508L13.4512 2.55841C13.6104 2.46288 13.7971 2.4233 13.9814 2.44594C14.1657 2.46859 14.3372 2.55217 14.4687 2.68341L15.317 3.53175C15.4482 3.66317 15.5318 3.83466 15.5545 4.019C15.5771 4.20335 15.5375 4.38997 15.442 4.54925L14.5253 6.07675C14.7087 6.42119 14.8587 6.7823 14.9753 7.16008L16.7028 7.59258C16.883 7.63772 17.043 7.74179 17.1573 7.88824C17.2716 8.0347 17.3337 8.21514 17.3337 8.40091V9.59925C17.3337 9.78502 17.2716 9.96547 17.1573 10.1119C17.043 10.2584 16.883 10.3624 16.7028 10.4076L14.9753 10.8401C14.8587 11.2179 14.7087 11.579 14.5253 11.9234L15.442 13.4509C15.5375 13.6102 15.5771 13.7968 15.5545 13.9812C15.5318 14.1655 15.4482 14.337 15.317 14.4684L14.4687 15.3167C14.3372 15.448 14.1657 15.5316 13.9814 15.5542C13.7971 15.5769 13.6104 15.5373 13.4512 15.4417L11.9237 14.5251C11.5792 14.7084 11.2181 14.8584 10.8403 14.9751L10.4078 16.7026C10.3627 16.8828 10.2586 17.0427 10.1122 17.157C9.96571 17.2713 9.78527 17.3334 9.59949 17.3334H8.40116C8.21538 17.3334 8.03494 17.2713 7.88849 17.157C7.74203 17.0427 7.63797 16.8828 7.59283 16.7026L7.16033 14.9751C6.7859 14.8594 6.4232 14.7087 6.07699 14.5251L4.54949 15.4417C4.39022 15.5373 4.20359 15.5769 4.01925 15.5542C3.8349 15.5316 3.66341 15.448 3.53199 15.3167L2.68366 14.4684C2.55242 14.337 2.46883 14.1655 2.44619 13.9812C2.42354 13.7968 2.46313 13.6102 2.55866 13.4509L3.47533 11.9234C3.29169 11.5772 3.14103 11.2145 3.02533 10.8401L1.29783 10.4076C1.11776 10.3625 0.957908 10.2585 0.843628 10.1122C0.729348 9.96597 0.667183 9.78571 0.666992 9.60008V8.40175C0.666997 8.21597 0.729077 8.03553 0.843372 7.88907C0.957666 7.74262 1.11762 7.63856 1.29783 7.59341L3.02533 7.16091C3.14199 6.78314 3.29199 6.42203 3.47533 6.07758L2.55866 4.55008C2.46313 4.3908 2.42354 4.20418 2.44619 4.01984C2.46883 3.83549 2.55242 3.664 2.68366 3.53258L3.53199 2.68341C3.66341 2.55217 3.8349 2.46859 4.01925 2.44594C4.20359 2.4233 4.39022 2.46288 4.54949 2.55841L6.07699 3.47508C6.42144 3.29175 6.78255 3.14175 7.16033 3.02508L7.59283 1.29758C7.63793 1.11751 7.74187 0.957663 7.88816 0.843384C8.03444 0.729104 8.21469 0.666939 8.40033 0.666748H9.59866C9.78443 0.666753 9.96488 0.728833 10.1113 0.843128C10.2578 0.957422 10.3618 1.11738 10.407 1.29758L10.8403 3.02508ZM9.00033 12.3334C9.88438 12.3334 10.7322 11.9822 11.3573 11.3571C11.9825 10.732 12.3337 9.88414 12.3337 9.00008C12.3337 8.11603 11.9825 7.26818 11.3573 6.64306C10.7322 6.01794 9.88438 5.66675 9.00033 5.66675C8.11627 5.66675 7.26842 6.01794 6.6433 6.64306C6.01818 7.26818 5.66699 8.11603 5.66699 9.00008C5.66699 9.88414 6.01818 10.732 6.6433 11.3571C7.26842 11.9822 8.11627 12.3334 9.00033 12.3334Z" fill="#2E3646"/>
                          </svg>
                          Ganti Part Lain
                        </button>
                        <button class="action-btn btn-view" @click="openModal('modalAddPart')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M7 0C7.32762 0 7.64182 0.130147 7.87349 0.361809C8.10515 0.593472 8.23529 0.907674 8.23529 1.23529V5.76471H12.7647C13.0923 5.76471 13.4065 5.89485 13.6382 6.12651C13.8699 6.35818 14 6.67238 14 7C14 7.32762 13.8699 7.64182 13.6382 7.87349C13.4065 8.10515 13.0923 8.23529 12.7647 8.23529H8.23529V12.7647C8.23529 13.0923 8.10515 13.4065 7.87349 13.6382C7.64182 13.8699 7.32762 14 7 14C6.67238 14 6.35818 13.8699 6.12651 13.6382C5.89485 13.4065 5.76471 13.0923 5.76471 12.7647V8.23529H1.23529C0.907674 8.23529 0.593472 8.10515 0.361809 7.87349C0.130147 7.64182 0 7.32762 0 7C0 6.67238 0.130147 6.35818 0.361809 6.12651C0.593472 5.89485 0.907674 5.76471 1.23529 5.76471H5.76471V1.23529C5.76471 0.907674 5.89485 0.593472 6.12651 0.361809C6.35818 0.130147 6.67238 0 7 0Z" fill="#2E3646"/>
                          </svg>
                          Tambah Part
                        </button>
                      </div>
                    </div>
                    <!-- End Of Action Button -->
                    <!-- Summary Of Changes Section -->
                     <div class="col-lg-2" v-if="itemChoose"></div>
                     <div class="col-lg-10 mt-3" v-if="itemChoose">
                      
                      <div class="summary-container">
                        <div class="info-header mb-2" >Ringkasan Perubahan</div>
                        <div >
                          <div class="summary-item-container mb-2" v-if="changedMainParts.length > 0">
                            <div class="summary-item-header">
                              <div 
                                class="item-badge ticket-badge"
                                style="background-color:#EAF5FE; color: #247FEC;"
                              >
                                Ganti Part Utama
                              </div>
                              <div>
                                <!-- <button class="trash-button"  title="Hapus"> -->
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="deleteIconBtn" @click="handleDelete('mainPartChange')">
                                    <path d="M5.64062 9.04199L5.64062 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M8.35938 9.04199L8.35937 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M0.875 3.59717H13.125V3.59717C13.125 3.59717 13.125 3.59717 13.125 3.59717C11.9974 3.59717 11.0833 4.51125 11.0833 5.63883C11.0833 5.63883 11.0833 5.63883 11.0833 5.63884V8.36105C11.0833 10.286 11.0833 11.2484 10.4853 11.8464C9.88735 12.4444 8.9249 12.4444 7 12.4444V12.4444C5.0751 12.4444 4.11265 12.4444 3.51466 11.8464C2.91667 11.2484 2.91667 10.286 2.91667 8.36106V5.63884C2.91667 5.63883 2.91667 5.63883 2.91667 5.63883C2.91667 4.51125 2.00258 3.59717 0.875 3.59717C0.875 3.59717 0.875 3.59717 0.875 3.59717V3.59717Z" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M5.68353 1.12721C5.76108 1.05485 5.93196 0.990918 6.16967 0.945317C6.40738 0.899717 6.69864 0.875 6.99826 0.875C7.29789 0.875 7.58915 0.899717 7.82686 0.945317C8.06457 0.990918 8.23545 1.05485 8.313 1.12721" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                  </svg>
                                <!-- </button> -->
                              </div>
                            </div>
                            <div class="mt-3">
                              <table class="table table-bordered">
                                <thead class="table-light">
                                  <tr>
                                    <th scope="col" style="border-top-left-radius: 0.5rem">Part Dilepas</th>
                                    <th scope="col" style="border-top-right-radius: 0.5rem">Part Pengganti</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(part, index) in changedMainParts" :key="index">
                                    <!-- <td>{{ part.itemName }}</td> -->
                                    <!-- <td>
                                      {{ part.itemName }}
                                    </td> -->
                                    <td>
                                      <small class="text-muted d-block" style="font-size:11px;">Nama Part</small>
                                      {{ part.itemName }}
                                    </td>
                                    <td>
                                      <small class="text-muted d-block" style="font-size:11px;">Nama Part {{ part.hasBatchNo }}</small>
                                      {{ part.itemName }}
                                      <div class="mt-2" v-if="part.hasBatchNo">
                                        <small class="text-muted d-block" style="font-size:11px;">Nomor Batch</small>
                                        <select
                                          v-model="changedMainParts[index].inputBatchNo"
                                          class="form-control form-control-sm"
                                          style="border-radius: 6px;"
                                        >
                                          <option value="" disabled>Pilih Batch...</option>
                                          <option
                                            v-for="batch in (part.batchOptions || [])"
                                            :key="batch.value"
                                            :value="batch.value"
                                          >
                                            {{ batch.label }}
                                          </option>
                                        </select>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            
                          </div>
                          <div class="summary-item-container mb-2" v-if="selectedOldParts.length > 0 && selectedNewParts.length > 0">
                            <div class="summary-item-header">
                              <div 
                                class="item-badge ticket-badge"
                                style="background-color:#FEF4EA; color: #F57A1A;"
                              >
                                Ganti Part Lain
                              </div>
                              <div>
                                <!-- <button class="trash-button"  title="Hapus"> -->
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="deleteIconBtn" @click="handleDelete('changeWithOtherPart')">
                                    <path d="M5.64062 9.04199L5.64062 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M8.35938 9.04199L8.35937 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M0.875 3.59717H13.125V3.59717C13.125 3.59717 13.125 3.59717 13.125 3.59717C11.9974 3.59717 11.0833 4.51125 11.0833 5.63883C11.0833 5.63883 11.0833 5.63883 11.0833 5.63884V8.36105C11.0833 10.286 11.0833 11.2484 10.4853 11.8464C9.88735 12.4444 8.9249 12.4444 7 12.4444V12.4444C5.0751 12.4444 4.11265 12.4444 3.51466 11.8464C2.91667 11.2484 2.91667 10.286 2.91667 8.36106V5.63884C2.91667 5.63883 2.91667 5.63883 2.91667 5.63883C2.91667 4.51125 2.00258 3.59717 0.875 3.59717C0.875 3.59717 0.875 3.59717 0.875 3.59717V3.59717Z" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M5.68353 1.12721C5.76108 1.05485 5.93196 0.990918 6.16967 0.945317C6.40738 0.899717 6.69864 0.875 6.99826 0.875C7.29789 0.875 7.58915 0.899717 7.82686 0.945317C8.06457 0.990918 8.23545 1.05485 8.313 1.12721" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                  </svg>
                                <!-- </button> -->
                              </div>
                            </div>
                            <div class="mt-3">
                              <table class="table table-bordered">
                                <thead class="table-light">
                                  <tr>
                                    <th scope="col" style="border-top-left-radius: 0.5rem">Part Dilepas</th>
                                    <th scope="col" style="border-top-right-radius: 0.5rem">Part Pengganti</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(part, index) in selectedOldParts" :key="index">
                                    <td>
                                      <small class="text-muted d-block" style="font-size:11px;">Nama Part</small>
                                      {{ part.itemName }}
                                    </td>
                                    <!-- <td>{{ selectedNewParts[index].itemName }}</td> -->
                                    <td>
                                      <small class="text-muted d-block" style="font-size:11px;">Nama Part</small>
                                      {{ selectedNewParts[index].itemName }}
                                      <div class="mt-2" v-if="selectedNewParts[index].hasBatchNo">
                                        <small class="text-muted d-block" style="font-size:11px;">Nomor Batch</small>
                                        <select
                                          v-model="selectedNewParts[index].inputBatchNo"
                                          class="form-control form-control-sm"
                                          style="border-radius: 6px;"
                                        >
                                          <option value="" disabled>Pilih Batch...</option>
                                          <option
                                            v-for="batch in (selectedNewParts[index].batchOptions || [])"
                                            :key="batch.batchNumber"
                                            :value="batch.batchNumber"
                                          >
                                            {{ batch.batchNumber }}
                                          </option>
                                        </select>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="summary-item-container" v-if="addedParts.length > 0">
                            <div class="summary-item-header">
                              <div 
                                class="item-badge ticket-badge"
                                style="background-color:#F7F0F6; color: #88527F;"
                              >
                                Tambah Part
                              </div>
                              <div>
                                <!-- <button class="trash-button"  title="Hapus"> -->
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="deleteIconBtn" @click="handleDelete('addedPart')">
                                    <path d="M5.64062 9.04199L5.64062 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M8.35938 9.04199L8.35937 7.00033" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M0.875 3.59717H13.125V3.59717C13.125 3.59717 13.125 3.59717 13.125 3.59717C11.9974 3.59717 11.0833 4.51125 11.0833 5.63883C11.0833 5.63883 11.0833 5.63883 11.0833 5.63884V8.36105C11.0833 10.286 11.0833 11.2484 10.4853 11.8464C9.88735 12.4444 8.9249 12.4444 7 12.4444V12.4444C5.0751 12.4444 4.11265 12.4444 3.51466 11.8464C2.91667 11.2484 2.91667 10.286 2.91667 8.36106V5.63884C2.91667 5.63883 2.91667 5.63883 2.91667 5.63883C2.91667 4.51125 2.00258 3.59717 0.875 3.59717C0.875 3.59717 0.875 3.59717 0.875 3.59717V3.59717Z" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                    <path d="M5.68353 1.12721C5.76108 1.05485 5.93196 0.990918 6.16967 0.945317C6.40738 0.899717 6.69864 0.875 6.99826 0.875C7.29789 0.875 7.58915 0.899717 7.82686 0.945317C8.06457 0.990918 8.23545 1.05485 8.313 1.12721" stroke="#BF2600" stroke-width="1.53125" stroke-linecap="round"/>
                                  </svg>
                                <!-- </button> -->
                              </div>
                            </div>
                            <div class="mt-3">
                              <table class="table table-bordered">
                                <thead class="table-light">
                                  <tr>
                                    <th scope="col" style="border-top-left-radius: 0.5rem">Part Ditambah</th>
                                    <th scope="col" style="border-top-right-radius: 0.5rem"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(part, index) in addedParts" :key="index">
                                    <td>
                                      <small class="text-muted d-block" style="font-size:11px;">Nama Part</small>
                                      {{ part.itemName }}
                                    </td>
                                    <td v-if="part.hasBatchNo">
                                      <small class="text-muted d-block" style="font-size:11px;">Nomor Batch</small>
                                      <select
                                        v-model="addedParts[index].inputBatchNo"
                                        class="form-control form-control-sm"
                                        style="border-radius: 6px;"
                                      >
                                        <option value="" disabled>Pilih Batch...</option>
                                        <option
                                          v-for="batch in (part.batchOptions || [])"
                                          :key="batch.batchNumber"
                                          :value="batch.batchNumber"
                                        >
                                          {{ batch.batchNumber }}
                                        </option>
                                      </select>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                     </div>
                    <!-- End of summary of changes section -->
                  </div>
                  
                  <div class="text-right my-5">
                    <button
                      class="btn btn-primary py-2 px-3" 
                      v-if="!loadingBtnSave" :disabled="!itemChoose || (changedMainParts.length == 0 && (selectedOldParts.length == 0 && selectedNewParts.length == 0 ) && addedParts.length == 0)" 
                      @click="changeSparepart"
                    >
                      Ubah Sparepart
                    </button>
                    <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;"> Loading</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalChangeMainPart
        ref="modalChangeMainPartRef"
        :partData="mainPartData" 
        :submitChanges="changeMainPart"
        :currentSelected="changedMainParts"
      />

      <ModalChangeWithOtherPart
        ref="modalChangeWithOtherPartRef"
        :unitInfo="itemChoose"
        :warehouse="warehouse"
        :submitChanges="changeWithOtherPart"
        :currentSelectedOldPart="selectedOldParts"
        :currentSelectedNewPart="selectedOldParts"
      />

      <ModalAddPart
        ref="modalAddPartRef"
        :unitInfo="itemChoose"
        :warehouse="warehouse"
        :submitChanges="addParts"
        :currentSelectedPart="addedParts"
      />
    </div>
    </template>
    
    <script>
    import Multiselect from 'vue-multiselect';
    import SideBar from '../SideBar.vue';
    import Swal from "sweetalert2";

    // Cuctom Component
    import AutocompleteInput from './CustomComponent/AutocompleteInput.vue';
    import ModalChangeMainPart from './CustomComponent/ModalChangeMainPart.vue';
    import ModalChangeWithOtherPart from './CustomComponent/ModalChangeWithOtherPart.vue';
    import ModalAddPart from './CustomComponent/ModalAddPart.vue';
    
    export default {
      name: 'ChangeSpecPage',
      components: {
        Multiselect,
        SideBar,
        AutocompleteInput,
        ModalChangeMainPart,
        ModalChangeWithOtherPart,
        ModalAddPart,
      },
      data() {
        return {
          spaceRegex: /[\u00A0\uFEFF\u202F]/g,
          permission: [],
          admin: '',
          adminId: '',
          warehouse: '',
          itemChoose: '',
          snsc: '',
          part: '',
          selectWarehouse: ['Roxy Warehouse - ASN', 'Roxy Staging - ASN'],
          loadingBtnSave: false,
          selectedOldParts : [],
          selectedNewParts : [],
          changedMainParts : [],
          addedParts:[],
          mainPartData: [],
        }
      },
      methods: {
        getBatchList(item) {
          let warehousePayload = `Roxy Warehouse - ASN`

          // if(purpose == 'change part' && this.warehouse.includes('Staging')) {
          return this.$http.post(process.env.ASSEMBLY_GET_BATCH_BY_ITEM_CODE, {
            itemCode: item.itemCode,
            // warehouse: purpose == 'change part' ? warehousePayload : this.warehouse == 'Roxy Trouble - ASN'? 'Roxy Repair - ASN' : this.warehouse
            warehouse : warehousePayload
          }, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          .then(response => {
            if (response.data.status == 200) {
             
              console.log('from get function')
              console.log(response.data.data)
              return response.data.data
            } else {
              swal('Error', res.data.message, 'error')
              return []
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
              return []
            })
          })
        },
        handleDelete(type) {
          if(type == 'mainPartChange') {
            this.changedMainParts = []
          } else if(type == 'changeWithOtherPart') {
            this.selectedOldParts = []
            this.selectedNewParts = []
          } else if (type == 'addedPart') {
            this.addedParts = []
          }
        },
        changeMainPart(parts) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });

          // this.changedMainParts = parts
          this.changedMainParts = parts.map(p => ({
            ...p,
            inputBatchNo: '',
            batchOptions: [] // isi dari API jika ada
          }))

          swalWithBootstrapButtons.fire({
            title: "Success",
            text: `Informasi Pergantian Part Utama berhasil tersimpan pada Ringkasan Perubahan`,
            icon: "success",
          }).then(result => {
            this.closeModal('modalChangeMainPart')
          })
        },
        async changeWithOtherPart(oldParts,newParts) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });
          // this.selectedNewParts = newParts
          this.selectedNewParts = await Promise.all(
            newParts.map(async (p) => {
              const batchOptions = await this.getBatchList(p);
              return {
                ...p,
                inputBatchNo: '',
                batchOptions: batchOptions || []
              };
            })
          );
          this.selectedOldParts = oldParts
          swalWithBootstrapButtons.fire({
            title: "Success",
            text: `Informasi Pergantian Part Utama berhasil tersimpan pada Ringkasan Perubahan`,
            icon: "success",
          }).then(result => {
            this.closeModal('modalChangeWithOtherPart')
          })
        },
        async addParts(parts){
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });

          this.addedParts = await Promise.all(
            parts.map(async (p) => {
              const batchOptions = await this.getBatchList(p);
              return {
                ...p,
                inputBatchNo: '',
                batchOptions: batchOptions || []
              };
            })
          );

          swalWithBootstrapButtons.fire({
            title: "Success",
            text: `Informasi Pergantian Part Utama berhasil tersimpan pada Ringkasan Perubahan`,
            icon: "success",
          }).then(result => {
            this.closeModal('modalAddPart')
          })
        },
        openModal(name) {
          $(`#${name}`).modal("show");

          // Tunggu modal selesai show, lalu panggil method child
          $(`#${name}`).on('shown.bs.modal', () => {
            if (name === 'modalChangeMainPart') {
              this.$refs.modalChangeMainPartRef.resetState();
            } else if (name === 'modalChangeWithOtherPart') {
              this.$refs.modalChangeWithOtherPartRef.resetState();
            } else if(name == 'modalAddPart') {
              this.$refs.modalAddPartRef.resetState();
            }
          });
          
        },
        closeModal(name) {
         $(`#${name}`).modal("hide");
        },
        getWarehouseList() {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });
          this.$http.get(process.env.ASSEMBLY_GET_WAREHOUSE_LIST,{
              headers: {
                'Asani-Token': localStorage.getItem('jwt')
              }
            }).then(res => {
              if (res.data.status == 200) {
                this.selectWarehouse = res.data.content ? res.data.content : [];
                } else {
                swalWithBootstrapButtons.fire({
                  title: "Failed",
                  text: `${res.data.message}`,
                  icon: "error",
                })
                .then((result) => {});
              }

            }).catch(error => {
              swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${error.response.data.message}`,
                icon: "error",
              })
            })
        },
        sidebar() {
          $("#wrapper").toggleClass("toggled");
        },
        toPage(e) {
          this.$router.push(e)
        },
        doSearchSn() {
          if(!this.snsc) {
            swal("Sorry", `Field SN/SC tidak boleh kosong !`, "error", {
              button: "Ok",
            })
          } else {
            this.$http.post(process.env.ASSEMBLY_SEARCH_SN_CHANGE_SPAREPART, {
              scsn: this.snsc.replace(this.spaceRegex, ' '),
              warehouse : this.warehouse
            }, {
              headers: {
                'Asani-Token': localStorage.getItem('jwt')
              }
            }).then(res => {
              if (res.data.status == 200) {
                this.itemChoose = res.data.content
                const mainPartArr = ['RAM','SSD','HDD','CASE CPU', 'PROCESSOR', 'VGA']
                let rawMainPartData = res.data.content.bomItem.filter(item => mainPartArr.includes(item.itemGroup.toUpperCase()))
                // this.mainPartData = rawMainPartData
                rawMainPartData.forEach(part => {
                  const {itemQty, itemCode} = part
                  for(let i = 0; i< itemQty;i++) {
                    this.mainPartData.push({...part,itemQty:1, tempId : `${itemCode}-${i}` })
                  }
                })
                this.warehouse = res.data.content.warehouse
              } else {
                swal('Error', res.data.message, 'error')
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
          }
          
        },
        changeSparepart() {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });

          const allItemsToCheck = [
            // ...this.changedMainParts,
            ...this.selectedNewParts,
            ...this.addedParts,
          ];
          const missingBatch = allItemsToCheck.some(p => p.hasBatchNo && !p.inputBatchNo);
          if (missingBatch) {
            swalWithBootstrapButtons.fire({
              title: "Perhatian",
              text: "Terdapat item yang membutuhkan Nomor Batch namun belum dipilih. Harap lengkapi terlebih dahulu.",
              icon: "warning",
            });
            return;
          }

          this.loadingBtnSave = true
       

          this.$http.post(`${process.env.ASSEMBLY_SAVE_CHANGE_SPAREPART}`, {
            scsn: this.snsc.trim(),
            stockCode : this.itemChoose.stockCode,
            warehouse : this.warehouse,
            changedMainPart : this.changedMainParts,
            oldSparepart : this.selectedOldParts,
            newSparepart : this.selectedNewParts,
            addedPart : this.addedParts,
            bomItem : this.itemChoose.bomItem,
          }, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          }).then(res => {
            this.loadingBtnSave = false
            if (res.data.status == 200) {
             swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Berhasil mengganti sparepart`,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                }
              });
            } else {
              console.log('error')
              swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${res.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
            }
          })
          .catch(error => {
            swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              this.loadingBtnSave = false
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
          })
    
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
          localStorage.removeItem('jwt')
          localStorage.removeItem('admin_name')
          localStorage.removeItem('roles')
          localStorage.removeItem('user_email')
          localStorage.removeItem('admin_id')
          localStorage.removeItem('changeCatalogPermission')
          this.$router.push('/')
        },
        cekLogin() {
          if (localStorage.getItem('jwt') == null) {
            this.$router.push('/')
          }
        },
        cekPermission() {
          this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
          for (var i = 0; i < this.permission.length; i++) {
            if(this.permission[i] == '24.1') {
              this.viewChangeSparepart = true
            }
          }
          if (this.viewChangeSparepart == false) {
            this.$router.push('/')
          }
        },
      },
      created() {
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
        this.getWarehouseList()
      }
    }
    </script>
    
    <style scoped>
    .deleteIconBtn {
      cursor: pointer;
      margin-right: 0.15rem;
    }
    .deleteIconBtn:hover {
      transform: translateY(-1px);
      box-shadow: 0 1px 20px rgba(220, 53, 69, 0.3);
    }

    .table {
      font-size: 14px;
      margin-bottom: 0rem;;
    }

    .table th {
      font-weight: 600;
      color: #2E3646;
      background-color: #EBEBEB;
    }

    .summary-item-header {
      display: flex;
      justify-content: space-between;
    }
    .item-badge {
      display: inline-block;
      padding: 0.5em 0.8em;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 1rem;
      transition: color 0.15s;
      margin-right: 2px;
    }
    .summary-container {
      padding: 10px;
      background-color: #F8F9FA;
      border-radius: 8px;
      border: 1px solid  #CFD3D9;
    }

    .summary-item-container {
      padding: 10px;
      background-color: #FFFFFF;
      border-radius: 8px;
      border: 1px solid  #CFD3D9;
    }

    .laptop-info-container {
      display: flex;
      align-items: flex-start;
      gap: 20px;
      padding: 10px;
      font-family: Arial, sans-serif;
      background-color: #F8F9FA;
      border-radius: 8px;
      border: 1px solid  #CFD3D9;
    } 
    .info-unit-section {
      flex: 1;
      border-radius: 6px;
      overflow: hidden;
    }
    .info-header {
      font-weight: 500;
      color: #2E3646;
      font-size: 16px;
    }
    .info-content {
      padding: 15px;
    }
    .info-item {
      margin-bottom: 8px;
      line-height: 1.4;
      color: #2E3646;
      font-size: 16px;
    }
    /* End of unit info */
    /* Action Button */
    .button-group {
      display: flex;
      gap: 8px;
      padding-top: 15px;
    }

    .action-btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 8px 12px;
      border: 1px solid;
      border-radius: 62.5rem;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      background-color: white;
      text-decoration: none;
    }

    .action-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .action-btn:active {
      transform: translateY(0);
    }
    /* End of action Button */

    .component-border {
      border: 1px solid rgb(206, 212, 218);
      background-color: rgb(233, 236, 239);
    }
    
    .menu-link {
      text-decoration: none;
      color: #00023b;
    }
    
    .menu-link:active {
      text-decoration: none;
      color: #00023b;
    }
    
    .menu-link:hover {
      text-decoration: none;
      color: #00023b;
    }
    
    .btn-account {
      font-size: 16px;
    }
    
    .navbar-collapse-button:focus {
      border: none;
      outline: none !important;
    }
    
    .navbar-collapse-button:after {
      border: none;
      outline: none !important;
    }
    .asani-search-input {
      border: 1px solid #eee;
      border-radius: 8px;
      width: 100%;
      padding: 6px 12px 6px 40px;
      box-sizing: border-box;
      position: relative;
      font-size: 12px;
      line-height: 1.5;
      flex: 1;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
      background-repeat: no-repeat;
      background-position: 12px;
    }
    .asani-search-input:focus,
    .asani-search-input[aria-expanded=true] {
      border-color: rgba(0, 0, 0, .12);
      background-color: #fff;
      outline: 0;
    }
    [data-position=below] .asani-search-input[aria-expanded=true] {
      border-bottom-color: transparent;
      border-radius: 8px 8px 0 0;
    }
    [data-position=above] .asani-search-input[aria-expanded=true] {
      border-top-color: transparent;
      border-radius: 0 0 8px 8px;
      z-index: 2;
    }
    .asani-search[data-loading=true]:after {
      content: "";
      border: 3px solid rgba(0, 0, 0, .12);
      border-right-color: rgba(0, 0, 0, .48);
      border-radius: 100%;
      width: 20px;
      height: 20px;
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      animation: rotate 1s linear infinite;
    }
    .asani-search-result-list {
      margin: 0;
      border: 1px solid rgba(0, 0, 0, .12);
      padding: 0;
      box-sizing: border-box;
      max-height: 296px;
      overflow-y: auto;
      background: #fff;
      list-style: none;
    }
    [data-position=below] .asani-search-result-list {
      margin-top: -1px;
      border-top-color: transparent;
      border-radius: 0 0 8px 8px;
      padding-bottom: 8px;
    }
    [data-position=above] .asani-search-result-list {
      margin-bottom: -1px;
      border-bottom-color: transparent;
      border-radius: 8px 8px 0 0;
      padding-top: 8px;
    }
    .asani-search-result {
      cursor: default;
      padding: 12px 12px 12px 48px;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
      background-repeat: no-repeat;
      background-position: 12px;
      width: 80%;
    }
    .asani-search-result:hover,
    .asani-search-result[aria-selected=true] {
      background-color: none;
    }
    .menu-toggler:focus {
      outline: none;
      background: none;
      border: none;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/Assembly/ChangeSparepartPage.vue